export const addNameToText = (text, name) => {
  return name ? text.replace("${Name}", name) : text;
};